import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  dispatchClose() {
    this.dispatch('closeTag', { detail: { element: this.element } });
  }
}
